(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/game-grid.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/game-grid.js');
"use strict";


const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;

const CARD_IMAGE_SIZES = ['(min-width: 1024px) min(312px, calc(25vw - 24px))', '(min-width: 768px) min(312px, calc(100vw / 3 - 24px))', '(min-width: 480px) calc(100vw / 3 - 16px)', 'calc(50vw - 18px)'].join(', ');
const GameGrid = _ref => {
  let games = _ref.games;
  const TicketCard = svs.eInstant.components.TicketCard;
  const validateGameConfig = svs.eInstant.util.validateGameConfig;
  return React.createElement(Grid, null, React.createElement(GridRow, {
    className: "grid-flex-g-am-2 grid-flex-g-sm-1"
  }, games.filter(validateGameConfig).map(game => React.createElement(GridCol, {
    className: "u-flex u-flex-justify-content-center",
    key: game.cntTicketGameId,
    md: 3,
    sm: 4,
    xs: 6
  }, React.createElement(TicketCard, {
    className: "tickets-einstant-grid-card",
    imageSizes: CARD_IMAGE_SIZES,
    ticketConfig: game
  })))));
};
setGlobal('svs.eInstant.shared.GameGrid', GameGrid);

 })(window);